import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import { getItemSessionStorage } from "../../features/webStorageSaver";

type ObjectsOnMapPointInfoSlice = {
    objectFeatures: any,
    regionFeatures: any,
    federalRoadFeatures: any,
    expandedKeys: any
}

function getInitialState() {
    const featuresOnMapPoint = getItemSessionStorage("featuresOnMapPoint")
    const { objectFeatures, regionFeatures, federalRoadFeatures } = featuresOnMapPoint ?? {}
    const initialState: ObjectsOnMapPointInfoSlice = {
        objectFeatures: objectFeatures ?? [],
        regionFeatures: regionFeatures ?? [],
        federalRoadFeatures: federalRoadFeatures ?? [],
        expandedKeys: []
    }
    return initialState
}

export const objectsOnMapPointInfoSlice = createSlice({
    name: 'objectsOnMapPointInfo',
    initialState: getInitialState(),
    reducers: {
        setFeaturesOnMapPoint(state, action: PayloadAction<any>) {
            const { objectFeatures, regionFeatures, federalRoadFeatures } = action.payload ?? {}
            state.objectFeatures = objectFeatures
            state.regionFeatures = regionFeatures
            state.federalRoadFeatures = federalRoadFeatures
        },
        setExpandedKeys(state, action: PayloadAction<any>) {
            state.expandedKeys = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setFeaturesOnMapPoint, setExpandedKeys } = objectsOnMapPointInfoSlice.actions
export const objectsOnMapPointInfoReducer = objectsOnMapPointInfoSlice.reducer; 
